import React, { FC, ReactNode, useEffect, useState } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { ReactComponent as ArrowBackIcon } from 'assets/icons/arrow-back.svg';
import { Link, useLocation } from 'react-router-dom';
import { RightSideBarListType } from 'components/right-sidebar';
import { ROUTE_PREFIX } from 'utils/constants';

type BottomNavigationProps = {
  onConfirm: () => void;
  list: RightSideBarListType[];
  onNextClick?: () => void;
  backBtnDisabled?: boolean;
  loading?: boolean;
  disabled?: boolean;
  onNextText?: string;
  secondaryBtn?: ReactNode;
  removeAllNextSteps?: boolean;
  onConfirmText?: string;
};
const BottomNavigation: FC<BottomNavigationProps> = ({
  onConfirm,
  onConfirmText = 'Confirm',
  list = [],
  backBtnDisabled,
  loading,
  onNextClick,
  disabled,
  secondaryBtn,
  removeAllNextSteps
}) => {
  const [index, setIndex] = useState(0);
  const location = useLocation();
  const pathname = location.pathname;
  const baseRouteType = location.pathname.split('/')[1] ?? ''; //shop or food
  const appendRoute =
    ROUTE_PREFIX.FOOD.includes(baseRouteType) || ROUTE_PREFIX.SHOP.includes(baseRouteType)
      ? `/${baseRouteType}`
      : '';

  const isLastIndex = () => {
    return list.length - 1 === index;
  };

  const getPrevRoute = () => {
    if (index !== 0) return `${appendRoute}/${list[index - 1]?.link}`;
    return '..';
  };

  const getNextRoute = () => {
    if (!isLastIndex()) return `${appendRoute}/${list[index + 1]?.link}`;
    return '..';
  };

  const getCurrentIdx = () => {
    const currentIndex = list.findIndex(({ link }) => pathname.includes(link.split('?')[0]));
    setIndex(currentIndex);
  };

  useEffect(() => {
    getCurrentIdx();
  }, [location]);

  const backIsDisabled = () => {
    return index === 0 || backBtnDisabled;
  };

  return (
    <div className='flex gap-4 items-center w-full mt-12'>
      <Link
        to={getPrevRoute()}
        replace
        className={`${
          backIsDisabled()
            ? 'pointer-events-none cursor-not-allowed bg-opacity-50 text-opacity-40'
            : 'cursor-pointer'
        } inline-block w-9 h-9 bg-[#F5F4F4] px-[9px] text-[#B6AFAF] rounded-full hover:bg-gray-13 transition-all`}>
        <div className='w-full flex justify-center items-center h-full'>
          <ArrowBackIcon className={`${!backIsDisabled() ? 'text-gray-6' : 'text-gray-3'}`} />
        </div>
      </Link>

      <div className='ml-auto flex gap-5 items-center'>
        {secondaryBtn}
        {isLastIndex() || removeAllNextSteps ? (
          <Button
            onClick={onConfirm}
            small
            variant='block'
            color='primary'
            className='text-xs'
            disabled={disabled}
            loading={loading}>
            {onConfirmText}
          </Button>
        ) : (
          <Link to={getNextRoute()} className={`${disabled ? 'pointer-events-none' : ''}`} replace>
            <Button
              onClick={onNextClick}
              disabled={disabled}
              small
              variant='block'
              color='primary'
              className='text-xs'>
              Continue
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default BottomNavigation;
